<div class="page-layout blank p-24" fusePerfectScrollbar fxLayout="row">

    <!-- ASIDE -->
    <div fxFlex="19" fxFlex.xs="100" class="aside" fxHide.lt-md fxShow.gt-sm>
        <div>
            <img src="assets/images/iconos/icono_altausuarios.png" class="icon">
        </div>
    </div>
    <!-- END ASIDE -->

    <!-- CONTENT -->
    <div fxFlex="81" class="content" fxFlex.lt-md="100">

        <!-- BREADCRUMB -->
        <div class="breadcrumbs">
            <a (click)="linkPanel()">Panel de Inicio</a> » <a routerLink="/proveedores/otras-gestiones">Otras
                gestiones</a> » <span>Consultas</span>
        </div>

        <!-- TÍTULO -->
        <h2 class="page-subtitle">Consultas</h2>
        <p>Por consultas sobre facturación de asociados correspondientes a Omint o Swiss Medical deberás dirigirte a los canales habilitados de cada Obra social a la cual te encuentres facturando.
        </p>
        <p>Ingresa tu solicitud o consulta</p>
        <!-- FORMULARIO -->
        <form [formGroup]="formularioConsultas" (ngSubmit)="onSubmit()" novalidate>

            <div class="data">
                <div class="tw" fxFlex.xs="100">
                    <mat-form-field class="mat-fullwidth">
                        <mat-label>Observaciones</mat-label>
                        <textarea matInput formControlName="observaciones" placeholder="Ingrese su consulta o solicitud"
                            matTextareaAutosize="true" matAutosizeMinRows="4" matAutosizeMaxRows="10" maxlength="600">
                        </textarea>
                        <mat-hint align="end">
                            {{formularioConsultas.get('observaciones')?.value?.length || 0}}/600
                        </mat-hint>
                        <mat-error
                            *ngIf="formularioConsultas.get('observaciones')?.hasError('required') && formularioConsultas.get('observaciones')?.touched">
                            El campo observaciones es obligatorio.
                        </mat-error>
                        <mat-error *ngIf="formularioConsultas.get('observaciones')?.hasError('maxlength')">
                            El campo no puede exceder los 600 caracteres.
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div fxLayout="row">
                <button type="button" mat-raised-button id="btnEnviar" (click)="onSubmit()">Enviar</button>
                <button type="button" mat-raised-button id="btnCancelar" (click)="goBack()">Volver</button>
            </div>
        </form>

    </div>
</div>